export default function OverviewTab() {
  const stats = [
    { label: '材料データ', value: '1,248', icon: 'ri-box-3-fill', color: 'bg-blue-500', change: '+12%' },
    { label: '3Dモデル', value: '856', icon: 'ri-cube-fill', color: 'bg-purple-500', change: '+8%' },
    { label: '施工データ', value: '432', icon: 'ri-tools-fill', color: 'bg-orange-500', change: '+15%' },
    { label: '店舗数', value: '89', icon: 'ri-store-2-fill', color: 'bg-teal-500', change: '+5%' },
  ];

  const recentActivities = [
    { action: '新しい材料データを追加', user: '山田太郎', time: '5分前', icon: 'ri-add-circle-line', color: 'text-green-500' },
    { action: '3Dモデルを更新', user: '佐藤花子', time: '15分前', icon: 'ri-refresh-line', color: 'text-blue-500' },
    { action: '施工データを削除', user: '鈴木一郎', time: '30分前', icon: 'ri-delete-bin-line', color: 'text-red-500' },
    { action: '店舗情報を編集', user: '田中美咲', time: '1時間前', icon: 'ri-edit-line', color: 'text-orange-500' },
    { action: '材料パケットをアップロード', user: '高橋健太', time: '2時間前', icon: 'ri-upload-cloud-line', color: 'text-purple-500' },
  ];

  return (
    <div className="p-8">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">ダッシュボード概要</h2>
        <p className="text-gray-600">XR Webシステムの3D素材管理状況</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white rounded-xl p-6 border border-gray-200/80 hover:shadow-lg transition-shadow">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                <i className={`${stat.icon} text-2xl text-white`}></i>
              </div>
              <span className="text-sm font-semibold text-green-600">{stat.change}</span>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</h3>
            <p className="text-sm text-gray-600">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <h3 className="text-lg font-bold text-gray-900 mb-4">最近のアクティビティ</h3>
          <div className="space-y-4">
            {recentActivities.map((activity, index) => (
              <div key={index} className="flex items-start gap-4 pb-4 border-b border-gray-100 last:border-0 last:pb-0">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className={`${activity.icon} text-2xl ${activity.color}`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900">{activity.action}</p>
                  <p className="text-xs text-gray-500 mt-1">{activity.user} • {activity.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-200/80">
          <h3 className="text-lg font-bold text-gray-900 mb-4">ストレージ使用状況</h3>
          <div className="space-y-6">
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">材料データ</span>
                <span className="text-sm font-semibold text-gray-900">45.2 GB</span>
              </div>
              <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                <div className="h-full bg-blue-500 rounded-full" style={{ width: '65%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">3Dモデル</span>
                <span className="text-sm font-semibold text-gray-900">78.9 GB</span>
              </div>
              <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                <div className="h-full bg-purple-500 rounded-full" style={{ width: '82%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">施工データ</span>
                <span className="text-sm font-semibold text-gray-900">32.1 GB</span>
              </div>
              <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                <div className="h-full bg-orange-500 rounded-full" style={{ width: '48%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">店舗データ</span>
                <span className="text-sm font-semibold text-gray-900">12.5 GB</span>
              </div>
              <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                <div className="h-full bg-teal-500 rounded-full" style={{ width: '25%' }}></div>
              </div>
            </div>
            <div className="pt-4 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <span className="text-sm font-bold text-gray-900">合計使用量</span>
                <span className="text-sm font-bold text-gray-900">168.7 GB / 500 GB</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
